import { Components } from '@mui/material';

export const MuiFormControl: Components['MuiFormControl'] = {
  defaultProps: {
    variant: 'outlined',
  },
};
